<form [formGroup]="form" (ngSubmit)="save()">
  <h2 mat-dialog-title>Оплата · {{ data.orderLabel }}</h2>

  <div mat-dialog-content class="dialogContent">
    <mat-form-field appearance="outline">
      <mat-label>Источник оплаты</mat-label>
      <mat-select [value]="paymentSource" [disabled]="saving || accountUncertain" (selectionChange)="selectPaymentSource($event.value)">
        <mat-option value="NEW">Новая оплата</mat-option>
        <mat-option value="WALLET">С баланса клиента</mat-option>
        <mat-option value="MIXED">С баланса и доплата</mat-option>
      </mat-select>
    </mat-form-field>
    <section class="accountPayment" *ngIf="paymentSource !== 'NEW'">
      <mat-form-field appearance="outline"><mat-label>Организация</mat-label><mat-select [(value)]="accountOrgId" [disabled]="saving || accountUncertain" (selectionChange)="loadAccountSummary()"><mat-option *ngFor="let org of accountOrganizations" [value]="org.id">{{ org.name }}</mat-option></mat-select></mat-form-field>
      <mat-progress-bar *ngIf="accountLoading" mode="indeterminate"></mat-progress-bar>
      <div class="accountSummary" *ngIf="accountSummary as s"><span>Доступно <b>{{ s.available_credit | number:'1.2-2' }}</b></span><span>В заказах <b>{{ s.committed_credit | number:'1.2-2' }}</b></span><span>Долг <b>{{ s.debt | number:'1.2-2' }}</b></span></div>
      <mat-form-field appearance="outline" *ngIf="paymentSource === 'MIXED'"><mat-label>Использовать с баланса, грн</mat-label><input matInput type="number" min="0.01" [formControl]="walletAmount" [readonly]="saving || accountUncertain"></mat-form-field>
      <p class="paymentContext" *ngIf="paymentSource === 'MIXED'">С баланса {{ accountAmount | number:'1.2-2' }} + доплата {{ accountExtra | number:'1.2-2' }} грн</p>
      <p class="formError" *ngIf="accountBlockedReason">{{ accountBlockedReason }}</p>
      <p class="formError" *ngIf="accountError && accountSummary">{{ accountError }}</p>
      <section class="accountPreview" *ngIf="accountPreview as p"><b>Результат оплаты</b><p>К оплате {{p.plan.order_due_before | number:'1.2-2'}} → после оплаты останется {{p.plan.order_due_after | number:'1.2-2'}}</p><p>Доступно после {{ p.after.available_credit | number:'1.2-2' }} · в заказах {{ p.after.committed_credit | number:'1.2-2' }} · долг {{ p.after.debt | number:'1.2-2' }}</p><p class="formError" *ngFor="let reason of p.blocked_reasons">{{ reason.message }}</p></section>
    </section>
    <div class="formGrid">
      <mat-form-field appearance="outline">
        <mat-label>{{ paymentSource === 'MIXED' ? 'Всего оплатить, грн' : 'Сумма оплаты' }}</mat-label>
        <input matInput type="number" min="0.01" [formControl]="valueControl" [readonly]="saving || accountUncertain" />
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="paymentSource !== 'WALLET'">
        <mat-label>{{ paymentSource === 'MIXED' ? 'Способ доплаты' : 'Тип оплаты' }}</mat-label>
        <mat-select [formControl]="paymentTypeControl" [disabled]="saving || accountUncertain">
          <mat-option *ngFor="let type of moneyTypes" [value]="type">{{ type }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <p class="paymentContext" *ngIf="paymentSource !== 'WALLET' && isShiftPayment && !cashContextLoading">
      <mat-icon>today</mat-icon>
      {{ shiftContextLabel }}
    </p>

    <p class="formError" *ngIf="isCashPayment && cashContextError">
      {{ cashContextError }}
    </p>
    <p class="formError" *ngIf="isShiftPayment && !isCashPayment && cashContextError">
      {{ cashContextError }}
    </p>
    <p class="formError" *ngIf="isTerminalPayment && terminalProfilesError">
      {{ terminalProfilesError }}
    </p>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="dialogRef.close()" [disabled]="saving || accountUncertain">
      Отмена
    </button>
    <button *ngIf="paymentSource !== 'NEW'" mat-stroked-button type="button" (click)="calculateAccountPayment()" [disabled]="saving || accountUncertain || !!accountBlockedReason">Рассчитать</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="
        saving ||
        (paymentSource === 'NEW' && (cashPaymentBlocked || (isTerminalPayment && (terminalProfilesLoading || !!terminalProfilesError)))) ||
        (paymentSource !== 'NEW' && !accountUncertain && (!accountPreview?.allowed || !!accountBlockedReason))
      "
    >
      {{ accountConfirmLabel }}
    </button>
  </div>
</form>
